import http from 'common/http'
import {
  notificationsFetched,
  notificationsRead,
  notificationsDismissed,
  unreadNotificationsCountFetched,
  notificationsReadIds,
} from 'actions/notification'
import type { Notification } from 'state/notification.js'

type response = {
  data: Notification[] | Notification | { count: number }
  status: number
  statusText: string
}

export const fetchUnreadNotificationsCount = () => {
  return (dispatch) => {
    return http.get(`/notification/unread/count`).then((res: response) => {
      dispatch(unreadNotificationsCountFetched(res.data))
    })
  }
}

export const fetchNotifications = (pageNumber = 1) => {
  return (dispatch) => {
    return http
      .get('/notification', { params: { page: pageNumber } })
      .then((res: response) => {
        dispatch(notificationsFetched(res.data))
      })
  }
}

export const readNotifications = (ids) => {
  return (dispatch) => {
    return http.post(`/notification/read`, ids).then((res: response) => {
      dispatch(notificationsRead(res.data))
    })
  }
}

export const readAllNotifications = () => {
  return (dispatch) => {
    return http.post(`/notification/read/all`).then((res: response) => {
      dispatch(notificationsReadIds(res.data))
    })
  }
}

export const dismissNotifications = (ids) => {
  return (dispatch) => {
    return http.post(`/notification/dismiss`, ids).then((res: response) => {
      dispatch(notificationsDismissed(res.data))
    })
  }
}

export const dismissAllNotifications = () => {
  return (dispatch) => {
    return http.post(`/notification/dismiss/all`).then((res: response) => {
      dispatch(notificationsDismissed([]))
    })
  }
}
